class Config {
    get emptyImagePreviewPassport(): string {
        return (window as any).BaseApp.initData.emptyImagePreviewPassport;
    }
}


const config = new Config();

export {config};
